import { useEffect, useState } from "react";
import styles from "./capitalData.module.css";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../../features/filter/capitalFilterSlice";
import {
  capitalApi,
  useGetCapitalIntakesQuery,
} from "../../../features/api/capital/capitalApi";
import { AddCapital } from "../addCapital/AddCapital";
import { CommonFilter } from "../../common/textFilter/CommonFilter";
import dateFormatter from "../../../utils/dateFormatter";

export const CapitalData = () => {
  const [key, setKey] = useState("Capitals Intake");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Pagination States
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [totalPages, setTotalPages] = useState(null);
  const [capitals, setCapitals] = useState([]);
  const capitalFilter = useSelector((state) => state.capitalFilter);

  // Fetching data from API
  const { data, isLoading, isError } = useGetCapitalIntakesQuery({
    page: pageNo,
    size: pageSize,
    ...capitalFilter,
  });

  // Function to fetch next page of products
  const getNextPage = (page) => {
    dispatch(
      capitalApi.endpoints.getCapitalIntakes.initiate({
        page: page,
        size: pageSize,
        ...capitalFilter,
      })
    );
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 0) {
      setPageNo(newPage);
      getNextPage(newPage);
    }
  };

  // Handle page size change
  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value);
    setPageSize(newSize);
    setPageNo(0); // Reset to first page when page size changes
    getNextPage(0); // Fetch data for the first page with new page size
  };

  // When data is fetched, update the products state
  useEffect(() => {
    if (data?.content) {
      setCapitals(data.content);
      setTotalPages(data.totalPages);
    }
  }, [data]);

  return (
    <div className="container pt-5">
      <Tabs
        id="controlled-tab"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="Capitals Intake" title="Capitals Intake">
          <CommonFilter
            filterBy={"amount"}
            placeHolder={"5000"}
            label={"Amount"}
            filterSetter={setFilter}
          />

          <CommonFilter
            filterBy={"contributedBy"}
            placeHolder={"Mohammed HAQUE"}
            label={"Contributed By"}
            filterSetter={setFilter}
          />
          <CommonFilter
            filterBy={"createdBy"}
            placeHolder={"Mohammed HAQUE"}
            label={"Created By"}
            filterSetter={setFilter}
          />

          <div className={styles.tableContainer}>
            {isLoading ? (
              <p>Loading...</p>
            ) : isError ? (
              <p>Error fetching data</p>
            ) : (
              <>
                <table className={styles.customTable}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Amount </th>
                      <th>Contributed By </th>
                      <th>Created At </th>
                      <th>Intake Method </th>
                      <th>Created By </th>
                      <th>Note </th>
                    </tr>
                  </thead>
                  <tbody>
                    {capitals.length > 0 ? (
                      capitals.map((capital, idx) => (
                        <tr
                          key={capital.id}
                          // onClick={() => navigate(`/category/${category.id}`)}
                        >
                          <td>{idx + 1}</td>
                          <td>{capital.amount}</td>
                          <td className={styles.itemName}>
                            {capital.contributedBy}
                          </td>
                          <td>{dateFormatter(capital.createdAt)}</td>
                          <td>{capital.intakeMethod}</td>
                          <td>{capital.createdBy}</td>
                          <td>{capital.note}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className={styles.noData}>
                          No capital data found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {/* Pagination Controls */}
                <div className={styles.pagination}>
                  {/* Page Size Selector */}
                  <div className={styles.pageSizeSelector}>
                    <label htmlFor="pageSize">Page Size: </label>
                    <select
                      id="pageSize"
                      value={pageSize}
                      onChange={handlePageSizeChange}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                    </select>
                  </div>
                  <button
                    onClick={() => handlePageChange(pageNo - 1)}
                    disabled={pageNo === 0}
                  >
                    Previous
                  </button>
                  <span>
                    Page {pageNo + 1} of {totalPages}
                  </span>
                  <button
                    onClick={() => handlePageChange(pageNo + 1)}
                    disabled={
                      !data?.content?.length || totalPages === pageNo + 1
                    }
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </div>
        </Tab>

        <Tab eventKey="Add Capital" title="Add Capital">
          <AddCapital onSuccess={() => setKey("Capitals Intake")} />
        </Tab>
      </Tabs>
    </div>
  );
};
